module.exports = __webpack_public_path__ + "static/media/login_banner.ad8c43c4.jpg";